import { t } from 'i18next';
import { selectUser } from '../../containers/Login/LoginSlice';
import { useAppSelector } from '../../hooks';
import { Container, SInfoRow, SInfoText } from './SidebarAvailabilityButton.style';
import ArrowRightImg from '../../assets/icons/chevron-right.svg';
import { getDateTextByLanguage } from './helpers';
import { SCircle } from '../UserProfileAvailabilityButton/UserProfileAvailabilityButton.style';
import { checkIsAvailable } from '../../utils/helperFunctions';

const SidebarAvailabilityButton = () => {
  const authUser = useAppSelector(selectUser);
  const { unavailableUntil = null } = authUser ?? {};
  const available = checkIsAvailable(unavailableUntil);

  return (
    <Container to="/sidebar/enable-not-available-mode">
      <SInfoRow>
        <SCircle isAvailable={available} />
        <SInfoText>
          <p className="status">{`${t('profile_status')}: ${t(
            available ? 'profile_available' : 'profile_not_available'
          )}`}</p>
          {!available && unavailableUntil && (
            <p className="endDate">
              {t('profile_not_available_mode_enabled_description', {
                dateTime: getDateTextByLanguage(unavailableUntil),
              })}
            </p>
          )}
        </SInfoText>
      </SInfoRow>
      <img height={20} className="editIcon" src={ArrowRightImg} alt="edit" role="editIcon" />
    </Container>
  );
};

export default SidebarAvailabilityButton;
